// @see https://bitbucket.org/flightscope/dto-schema/src/master/baseball/enum/session-contents.json
const SessionContents = {
    R: { key: 'R', name: 'Radar only' },
    RS: { key: 'RS', name: 'Radar and scoring' },
    RTS: { key: 'RTS', name: 'Radar, scoring and tagging' },
    RT: { key: 'RT', name: 'Radar and tagging' },
    S: { key: 'S', name: 'Scoring only' },
    T: { key: 'T', name: 'Tagging only' },
    TS: { key: 'TS', name: 'Scoring and tagging' },
};

export default SessionContents;